import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

class GetDuplicatesPreviewAPICall extends APICallV4 {
    _method = 'duplicates/preview';
    _type: Method = 'get';
    _retriesCount = 0;
}

export const getDuplicatesPreviewCall = () => new GetDuplicatesPreviewAPICall().makeRequest();
